import React from "react";

export const useComponentWillUnmount = (callback: () => void) => {
    React.useEffect(() => {
        return () => {
            callback();
        }
    }, []);
}